const SUPPORT_SESSION_STORAGE_KEY = 'support_session_id';
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const createSupportSessionId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = Math.floor(Math.random() * 16);
        const value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
    });
};

export const SUPPORT_NOTIFICATION_EMAIL = 'support@forexfundai.com';

export const getOrCreateSupportSessionId = () => {
    const existingSessionId = localStorage.getItem(SUPPORT_SESSION_STORAGE_KEY);

    if (existingSessionId && UUID_PATTERN.test(existingSessionId)) {
        return existingSessionId;
    }

    const sessionId = createSupportSessionId();
    localStorage.setItem(SUPPORT_SESSION_STORAGE_KEY, sessionId);
    return sessionId;
};

export const formatSupportTicketMessage = (subject: string, body: string) => {
    const trimmedSubject = subject.trim();
    const trimmedBody = body.trim();

    if (!trimmedSubject) {
        return trimmedBody;
    }

    return `Subject: ${trimmedSubject}\n\n${trimmedBody}`;
};

export const parseSupportTicketMessage = (content: string | null | undefined) => {
    const normalizedContent = (content || '').trim();

    if (!normalizedContent) {
        return {
            subject: null,
            body: ''
        };
    }

    if (!normalizedContent.startsWith('Subject:')) {
        return {
            subject: null,
            body: normalizedContent
        };
    }

    const [subjectLine, ...rest] = normalizedContent.split(/\r?\n/);
    const subject = subjectLine.slice('Subject:'.length).trim() || null;
    const body = rest.join('\n').trim();

    return {
        subject,
        body: body || normalizedContent
    };
};